
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20.8 23.2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M10.4 22.97l4.6-4.6-4.6-4.6v3.4c-1.6 0-3.1-.3-4.6-.8-1.3-.4-2.4-1.2-3.4-2.2-.8-.8-1.2-1.9-1.2-3 0-1.5.8-2.8 2-3.6-.9.8-1.7 1.6-2.3 2.4-.5.8-.8 1.7-.8 2.7 0 1.3.5 2.5 1.4 3.5 1 1.1 2.3 2 3.8 2.5 1.7.6 3.4.9 5.2.9l-.1 3.4zm0-22.9l-4.5 4.6 4.6 4.6v-3.5c1.5 0 3.1.3 4.5.8 1.3.4 2.4 1.2 3.4 2.2.8.8 1.2 1.9 1.2 3 0 1.5-.8 2.8-2 3.6.9-.6 1.7-1.3 2.3-2.2.5-.8.8-1.7.8-2.7 0-1.3-.5-2.5-1.4-3.5-1-1.1-2.3-2-3.8-2.5-1.5-.6-3.3-1-5.1-.9V.07z"}})])
          )
        }
      }
    